import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import { routes } from 'oo-routes';
import { Link } from 'react-router';

import './styles';

export default class Banner extends React.Component {
  render() {
    const columns = this.props.columns;

    return (
      <div className="Banner">
        <div className="ui container p-t-2 p-b-2">
          <div className="ui three column stackable grid">
            {
              _.map(columns, (column, index) => (
                <div key={index} className="column">
                  <div className="ui middle aligned grid">
                    <div className="row">
                      <div className="three wide column">
                        <i className={classnames(column.iconClass.class, 'medium')} />
                      </div>
                      <div className="thirteen wide column">
                        <h4 className="no-top no-bottom">{column.title}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
        <div className="ui fitted divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Banner/index.jsx